import { useState, useEffect } from 'react'
import Close from '../asset/img/modal-close.svg'

export const ViewQrImagePopup = ({ onClose, data }) => {
    const [currentIndex, setCurrentIndex] = useState(0)
    const [images, setImages] = useState([])

    useEffect(() => {
        if (data) {
            const imageArray = Array.isArray(data) ? data : [data]
            setImages(imageArray)
            setCurrentIndex(0)
        }
    }, [data])

    const goToNext = () => {
        setCurrentIndex((prevIndex) => 
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        )
    }

    const goToPrev = () => {
        setCurrentIndex((prevIndex) => 
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        )
    }

    if (!images || images.length === 0) {
        return null
    }

    return (
        <>
            <div
                className="modal d-block"
                id="view-multi-modal"
                tabIndex="-1"
                aria-labelledby="view-multi-modal"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg planogram-div">
                    <div className="modal-content rounded-0 p-2">
                        <img
                            id="close"
                            src={Close}
                            alt="X"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            className="modal-close"
                            onClick={() => onClose()}
                        />

                        <div className="modal-header rounded-0 align-items-center py-4 px-4">
                            <div className="col">
                                <h4 className="modal-title">
                                    Notification Images ({currentIndex + 1}/{images.length})
                                </h4>
                            </div>
                        </div>

                        <div className="modal-body font14 p-40">
                            <div
                                className="container"
                                style={{ 
                                    height: '60vh', 
                                    display: 'flex', 
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <div className="row mt-3 w-100" style={{ flex: 1 }}>
                                    <div className="col-12 d-flex justify-content-center align-items-center h-100">
                                        <img
                                            src={images[currentIndex]}
                                            alt={`Suspicious ${currentIndex + 1}`}
                                            crossOrigin="anonymous"
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '400px',
                                                objectFit: 'contain'
                                            }}
                                            onError={(e) => {
                                                e.target.onerror = null
                                                e.target.src = 'path/to/placeholder/image.jpg'
                                                e.target.alt = 'Image not available'
                                            }}
                                        />
                                    </div>
                                </div>

                                {images.length > 1 && (
                                    <div className="row mt-3">
                                        <div className="col-12 d-flex justify-content-center align-items-center">
                                            <button
                                                className="btn btn-secondary mx-2"
                                                onClick={goToPrev}
                                            >
                                                ← Previous
                                            </button>
                                            
                                            <span className="mx-3">
                                                {currentIndex + 1} of {images.length}
                                            </span>
                                            
                                            <button
                                                className="btn btn-secondary mx-2"
                                                onClick={goToNext}
                                            >
                                                Next →
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {images.length > 1 && (
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <div className="d-flex flex-wrap justify-content-center">
                                                {images.map((img, index) => (
                                                    <img
                                                        key={index}
                                                        src={img}
                                                        alt={`Thumbnail ${index + 1}`}
                                                        className={`thumbnail ${index === currentIndex ? 'active-thumbnail' : ''}`}
                                                        style={{
                                                            width: '80px',
                                                            height: '60px',
                                                            objectFit: 'cover',
                                                            margin: '5px',
                                                            cursor: 'pointer',
                                                            border: index === currentIndex ? '3px solid #007bff' : '1px solid #ddd',
                                                            opacity: index === currentIndex ? 1 : 0.7
                                                        }}
                                                        onClick={() => setCurrentIndex(index)}
                                                        onError={(e) => {
                                                            e.target.onerror = null
                                                            e.target.src = 'path/to/placeholder/thumbnail.jpg'
                                                        }}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn btn-primary"
                                onClick={() => onClose()}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-backdrop show"></div>
            
            <style jsx>{`
                .thumbnail:hover {
                    opacity: 1;
                    transform: scale(1.05);
                    transition: all 0.2s ease;
                }
                
                .active-thumbnail {
                    box-shadow: 0 0 10px rgba(0, 123, 255, 0.5);
                }
            `}</style>
        </>
    )
}